import { render, staticRenderFns } from "./8.vue?vue&type=template&id=54988acc&scoped=true&"
var script = {}
import style0 from "./8.vue?vue&type=style&index=0&id=54988acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54988acc",
  null
  
)

export default component.exports